
































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import VipTag from '@/api/vip/vipTag/index'
import appconst from '@/lib/appconst'
@Component({
  components: {},
})
export default class VipTagList extends AbpBase {
  columns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '标签名称',
      key: 'name',
      align: 'center',
    },
    {
      title: '会员人数',
      key: 'totalUserCount',
      align: 'center',
    },
    {
      title: '标签类型',
      slot: 'isAutoTag',
      align: 'center',
    },
    {
      title: '自动打标签条件',
      slot: 'totalTransaction',
      align: 'center',
    },
    // {
    //   title: '导购可见',
    //   slot: 'isActive',
    //   align: 'center'
    // },
    {
      title: '操作',
      slot: 'action',
      width: 170,
      align: 'center',
    },
  ]
  loading: boolean = false
  exporting: boolean = false
  tableData: any[] = []
  page = {
    totalCount: 0,
    currentPage: 1,
    maxResultCount: 10,
  }
  isCheckAll = false

  created() {
    this.getVipTagList()
  }
  mounted() {

  }
  /**
   * 获取会员标签列表
   */
  getVipTagList() {
    let { page } = this
    VipTag.getVipTagList(page.maxResultCount, page.currentPage).then((res) => {
      page.totalCount = res.data.totalCount
      this.tableData = res.data.items
    })
  }
  isActiveChange(id) {
    VipTag.updateActive(id).then((res) => {
      this.getVipTagList()
    })
  }

  /**
   * 新增/编辑
   */
  editFn(id?) {
    this.$router.push({
      name: 'editTag',
      query: {
        id: id,
      },
    })
  }

  /**
   * 删除运费模板
   */
  deleteTag(id) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.loading = true
        VipTag.deleteVipTag([id])
          .then((res) => {
            this.loading = false
            this.$Notice.success({ desc: '删除成功' })
            this.getVipTagList()
          })
          .catch((err) => {
            this.loading = false
          })
      },
    })
  }

  deleteSelectd() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      this.$Modal.confirm({
        title: '提示',
        content: `确认删除已选中订单？`,
        onOk: () => {
          this.loading = true
          let list: any = selection.map((item) => {
            return item.id
          })
          VipTag.deleteVipTag(list)
            .then((res) => {
              this.loading = false
              this.$Notice.success({ desc: '删除成功' })
              this.getVipTagList()
            })
            .catch((err) => {
              this.loading = false
            })
        },
      })
    } else {
      this.$Notice.warning({
        title: '请先选择标签',
      })
    }
  }

  changePage(e) {
    this.page.currentPage = e
    this.getVipTagList()
  }
  pageSizeChange(e) {
    this.page.maxResultCount = e
    this.page.currentPage = 1
    this.getVipTagList()
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }
  /**
   * 导出excel表格
   */
  exportExcel() {
    this.exporting = true
    // 调用接口
    // ProductRecommendApi.exportProductRecommendFile()
    //   .then((res) => {
    //     console.log(res)
    //     this.exporting = false
    //     this.download(res.data)
    //   })
    //   .catch((err) => {
    //     this.exporting = false
    //   })
  }
  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '会员标签.xlsx')

    document.body.appendChild(link)
    link.click()
  }
}
